// import { useFormik, validateYupSchema } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
// import Select from 'react-select'
// import * as Yup from 'yup';
import Modal from 'react-bootstrap/Modal';
import { SlButton, SlDrawer, SlTooltip, SlOption, SlSelect, SlInput, SlTab, SlTabGroup, SlTabPanel, SlIcon } from '@shoelace-style/shoelace/dist/react';
import { ScrollContainer } from 'react-indiana-drag-scroll';
// import { Formik, Form, Field } from 'formik';
import Button from 'react-bootstrap/Button';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";
import axios from "axios";

import { useDispatch, useSelector } from 'react-redux';

// import { decrement, increment } from '../../redux/counterSlice'

import api from "../../services/api"
import { Toast } from '../../shared/Toast'
import { formatDate, formatDateWithTime, formatDateYYYYMMDD, ISODateString, NEWISODateString } from "../../utils/dateFormat";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import { campaignStatus, roles, langoptions, languageOptions, stateOptions } from "../../utils/constants";
import Paginator from "../../shared/Paginator";
import { debounce } from "../../utils/Debounce";
import config from "../../config";
import { SetCampCount, SetOpsSales, SetComponentId } from '../../redux/counterSlice'
// import CreativeCreation from "../creatives/CreativeCreation";
// import PreviewFrame from "../PreviewFrame";
// import Budget from "./Budget";
// import CreativeSelection from "./CreativeSelection";
// import Start from "./Start";
// import Target from "./Target";
// import Date from "./Date";
import { UpdatedDate } from "../../utils/dateFormat";
import async from "async";
import { insert } from "formik";
import { click } from "@testing-library/user-event/dist/click";
import PreviewFrameEdit from "../PreviewFrameEdit";




const genderOptions = ["All", "Male", "Female"]
const osOptions = ["All", "Android", "IOS"]
const appCategoryOptions = ["All", "News", "Business", "Sports", "Cinema", "Special", "Politics"]
const actiontypeoptions = ["Shuffle", "Round robin"]
const payments = ["Unpaid", "Paid", "Wayoff"]

export const newStreamCreativeContext = React.createContext();
function NewsStream() {
    const [editDaily_cap, seteditDaily_cap] = useState(0)
    const [editDaily_cap_ind, seteditDaily_cap_ind] = useState(-1)
    const [editTotal_cap_ind, seteditTotal_cap_ind] = useState(-1)
    const [editTotal_cap, seteditTotal_cap] = useState(0)
    const [editTotalBudget_ind, seteditTotalBudget_ind] = useState(-1);
    const [editPosition_ind, seteditPosition_ind] = useState(-2)
    const [editTotalBudget, seteditTotalBudget] = useState(-1);
    const [editPosition, seteditPosition] = useState(-2)
    const [editTotalDaily_ind, seteditDailyBudget_ind] = useState(-1);
    const [editDailyBudget, seteditDailyBudget] = useState(-1);
    const [editstart_date_ind, seteditStart_date_ind] = useState(-1);
    const [editstart_date, seteditStart_date] = useState(0)
    const [editend_date_ind, seteditEnd_date_ind] = useState(-1);
    const [currentDate, setCurrentDate] = useState("")
    const [editend_date, seteditEnd_date] = useState(0);
    const [filter_sales_ops, setFiltersales_ops] = useState({ index: -1, value: -1 })
    const [creative_Names, setCreative_Names] = useState([])
    const [tarshow, setTarshow] = useState(false)
    const [newsDetails, setNewsDetails] = useState({})

    const navigate = useNavigate()


    // Filters
    // const currentDate = Math.round(new Date() / 1000)
    const [dateFilter, setDateFilter] = useState("");

    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [langfilter, setLangFilter] = useState('1')
    const Headdate = useSelector(state => state.Head.date)
    const [statefilter, setStatefilter] = useState(-1)
    const [districtselect, setSelectdistrict] = useState(-1)
    const [districtfilter, setDistrictfilter] = useState([])
    const [mandalselect, setSelectmandal] = useState(-1)
    const [mandalfilter, setMandalfilter] = useState([])
    const [villageselect, setSelectvillage] = useState(-1)
    const [villagefilter,setVillagefilter] = useState([])
    const [target_filter, setTarget_filter] = useState({lang_id:'1'})
    const dispatch = useDispatch()
    dispatch(SetComponentId(14))
    const getData = async ( page=0, target_filter = { lang_id: 1, state_id: -1, district_id: -1, mandal_id: -1, village_id: -1 }) => {
        try {
            setLoader(true);
            let res = await api({
                url: '/lineitems/getnewstream',
                method: 'POST',
                responseType: 'json',
                data: {
                    // page,
                    // limit: config.PER_PAGE,
                    target_filter
                }
            });
            if (res.code === 200) {
                setData(res.data);
                // setTotalPages(Math.ceil(parseInt(res.data.total) / config.PER_PAGE));
                // setSpent(res.data.spent)
            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }
    }
    const LanguageFilterChange = (e) => {
        setLangFilter(e.target.value)
        setDistrictfilter([])
        setMandalfilter([])
        setVillagefilter([])
        setCurrentPage(0);
        setTarget_filter({ lang_id: e.target.value, state_id: -1, district_id: -1, mandal_id: -1,village_id:-1 })
        getData( currentPage, { lang_id: e.target.value, state_id: -1, district_id: -1, mandal_id: -1, village_id:-1 });
        if (parseInt(e.target.value) === -1) {
            setStatefilter(-1)
            setLangFilter(-1)
            setSelectdistrict(-1)
            setSelectmandal(-1)
            setSelectvillage(-1)
        }
    }

    const StateFilterChange = async (value) => {
        setStatefilter(value)
        setMandalfilter([])
        setVillagefilter([])
        if (parseInt(value) !== -1) {
            try {
                let res = await api({
                    url: '/location/getDistrictsByStateId',
                    method: 'POST',
                    responseType: 'json',
                    data: { states: [value], langs: [langfilter] }
                })
                let districts = []
                for await (let item of res.data) {
                    const temp = { value: item, label: `${item.dist_name}` }
                    districts.push(temp)
                }
                setDistrictfilter(districts)
            } catch (error) {
                console.error(error);
                if (error.response.status === 401)
                    navigate("/")
            }
        }
        if (parseInt(value) === -1) {
            setSelectdistrict(-1)
            setStatefilter(-1)
            setSelectmandal(-1)
            setSelectvillage(-1)
        }
        setTarget_filter({ lang_id: target_filter.lang_id, state_id: value, district_id: -1, mandal_id: -1, village_id:-1 })
        getData(currentPage, { lang_id: target_filter.lang_id, state_id: value, district_id: -1, mandal_id: -1, village_id:-1 });

    }

    const DistrictFilterChanger = async (value) => {
        setSelectdistrict(value)
        setVillagefilter([])
        if (parseInt(value) !== -1) {
            try {
                let res = await api({
                    url: '/location/getMandalsnew',
                    method: 'POST',
                    responseType: 'json',
                    data: { districts: [value], langs: [langfilter] }
                })
                let mandals = []
                for await (let item of res.data) {
                    const temp = { value: item, label: `${item.mandal_name}` }
                    mandals.push(temp)
                }
                setMandalfilter(mandals)
            } catch (error) {
                console.error(error);
                if (error.response.status === 401)
                    navigate("/")
            }
        }
        if (parseInt(value) === -1) {
            setSelectdistrict(-1)
            setSelectmandal(-1)
            setSelectvillage(-1)
        }
        setTarget_filter({ district_id: value, mandal_id: -1, state_id: target_filter.state_id, lang_id: target_filter.lang_id, village_id: -1 })
        getData(currentPage, { district_id: value, mandal_id: -1, state_id: target_filter.state_id, lang_id: target_filter.lang_id, village_id: -1 });

    }

    const MandalFilterChange = async (value) => {
        setSelectmandal(value)
        if (parseInt(value) !== -1) {
            try {
                let res = await api({
                    url: '/location/getVillagesnew',
                    method: 'POST',
                    responseType: 'json',
                    data: { mandals: [value], langs: [langfilter], districts: [target_filter.district_id] }
                })
                let villages = []
                for await (let item of res.data) {
                    const temp = { value: item, label: `${item.village}` }
                    villages.push(temp)
                }
                setVillagefilter(villages)

            }
            catch (error) {
                console.error(error);
                if (error.response.status === 401)
                    navigate("/")
            }
        }
        if (parseInt(value) === -1) {
            setSelectvillage(-1)
            setVillagefilter([])
            setSelectmandal(-1)
        }
        setTarget_filter({ district_id: target_filter.district_id, mandal_id: value, village_id: -1, state_id: target_filter.state_id, lang_id: target_filter.lang_id })
    getData(currentPage, { district_id: target_filter.district_id, mandal_id: value, village_id :-1,state_id: target_filter.state_id, lang_id: target_filter.lang_id  });

        
    }
    const villageFilterChange = async(value)=>{
        setTarget_filter({...target_filter, village_id: value})
        getData(currentPage, {...target_filter, village_id: value})
    }
    useEffect(()=>{
        getData()
    },[])
    const getCreativeNames = async (ids, campaign_id, type) => {
        try {
          let res = await api({
            url: "/lineitems/creative_Names",
            method: "POST",
            responseType: 'json',
            data: { ids, campaign_id, type }
          })
          setCreative_Names(res.data)
        } catch (error) {
          if (error.response.status === 401)
            navigate("/")
        }
      }
    const getNewsDetails = async (post_id, news_type) => {
        try {
            let res = await api({
              url: "/lineitems/getnewsdetails",
              method: "POST",
              responseType: 'json',
              data: { post_id, news_type}
            })
            setCreative_Names(JSON.parse(JSON.stringify(res.data)));
          } catch (error) {
            if (error.response.status === 401)
              navigate("/")
          }
        }
    
   return(<>
    <div class="row">
        <div class="col-12">
            <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">News Stream</h4>
            </div>
        </div>
    </div>
    
    <div className="card">
        <div className="card-header">
            <div className="flex items-center gap-3" style={{"padding-bottom":"10px"}}>
                <aside className="flex items-center gap-3 justify-center">
                    {
                        ((localStorage.getItem("role") !== roles.advertiser) && (localStorage.getItem("role") !== roles.salesperson))}
                    
                   
                    {((localStorage.getItem("role") !== roles.advertiser) && (localStorage.getItem("role") !== roles.salesperson)) &&
                        <div>
                            <SlSelect placeholder="Select Language" name="lang" size="medium" onSlChange={LanguageFilterChange} value={langfilter}>
                                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                                {/* <SlOption value="-1">All</SlOption> */}
                                {
                                    languageOptions.map(item => {
                                        return <SlOption key={item.value} value={item.value}>{item.label}</SlOption>
                                    })
                                }
                            </SlSelect>
                        </div>}
                    {
                        langfilter !== -1 &&
                        <div>
                            <SlSelect placeholder="Select State" name="state" size="medium" onSlChange={(e) => { StateFilterChange(e.target.value) }}>
                                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                                <SlOption value="-1">All</SlOption>
                                {
                                    stateOptions.filter((item) => item.lang_id === +langfilter).map(item => {
                                        return (
                                            <SlOption key={item.state_id} value={item.state_id}>
                                                {item.state_name}
                                            </SlOption>
                                        );
                                    })
                                }
                            </SlSelect>
                        </div>}
                    {statefilter !== -1 &&
                        <div>
                            <SlSelect placeholder="Select District" name="district" size="medium" onSlChange={(e) => { DistrictFilterChanger(e.target.value) }}>
                                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                                <SlOption value="-1">All</SlOption>
                                {
                                    districtfilter.map(item => {
                                        return (
                                            <SlOption key={item.value.dist_id} value={item.value.dist_id}>
                                                {item.label}
                                            </SlOption>
                                        );
                                    })
                                }
                            </SlSelect>
                        </div>}

                    {
                        districtselect !== -1 &&
                        <div>
                            <SlSelect placeholder="Select Mandal" name="mandal" size="medium" onSlChange={(e) => { MandalFilterChange(e.target.value) }}>
                                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                                <SlOption value="-1">All</SlOption>
                                {
                                    mandalfilter.map(item => {
                                        return (
                                            <SlOption key={item.value.mandal_id} value={item.value.mandal_id}>
                                                {item.label}
                                            </SlOption>
                                        );
                                    })
                                }
                            </SlSelect>
                        </div>
                    }
                    {
                        mandalselect !== -1 &&
                        <div>
                            <SlSelect placeholder="Select Village" name="village" size="medium" onSlChange={(e) => { villageFilterChange(e.target.value) }}>
                                <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                                <SlOption value="-1">All</SlOption>
                                {
                                    villagefilter.map(item => {
                                        return (
                                            <SlOption key={item.value.village_id} value={item.value.village_id}>
                                                {item.label}
                                            </SlOption>
                                        );
                                    })
                                }
                            </SlSelect>
                        </div>
                    }

                </aside>
            </div>
            <div className="overflow-x-auto" >
                                    <ScrollContainer>
                                        <table className='table table-bordered'>
                                            <thead className="sticky top-0">
                                                <tr>
                                                    <th>SNO</th>
                                                    <th>Time</th>
                                                    <th>Type</th>
                                                    <th>news_type</th>
                                                    <th>Title</th>
                                                    <th>Views</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            {data?.length && !loader ? (
                                                <tbody>
                                                    {data?.map((item, index) => {
                                                        return (
                                                            <tr key={item.campaign_id} >
                                                                <td>{index + 1}</td>
                                                                <td>{item.stream_type !== "network_ad" ? formatDateWithTime(item.post_gmt) : ""}</td>
                                                                <td>{ <span className={(item.stream_type === "ad" || item.stream_type === "network_ad") ? "full-badge" : "partial-badge"}>{item.stream_type}</span> }</td>
                                                                <td>{(item.stream_type === "ad" || item.stream_type === "network_ad") ? item.creative_type : item.news_type}</td>
                                                               <td>{(item.stream_type === "ad" || item.stream_type === "network_ad") ? item.campaign_name : item.post_title}</td>
                                                               <td>{item.views}</td>
                                                                <td>{(localStorage.getItem("role") === roles.ops) && item.stream_type !== "network_ad" && <div  style={{ fontSize: "24px" }}>
                                                                    <sl-tooltip content="View" hoist>
                                                                        <sl-icon-button
                                                                            library="lucide"
                                                                            name="view"
                                                                            onClick={() => { if(item.stream_type === "ad") { getCreativeNames(item.creative_ids, item.campaign_id, item.type); setTimeout(() => { setTarshow(true) }, 0)}else {getNewsDetails(item.post_id, item.news_type);  setTimeout(() => { setTarshow(true) }, 0)} }}></sl-icon-button>
                                                                    </sl-tooltip>
                                                                </div>}</td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            ) : !data?.length && !loader ? (
                                                <NoDataFound colspan="15" />
                                            ) : (
                                                <TableLoader colspan="15" />
                                            )}
                                        </table>
                                    </ScrollContainer>
                </div>
               
        </div>
        <div>

           </div>
       </div >
       <SlDrawer
           open={tarshow}
           onSlAfterHide={() => { setTarshow(false); setCreative_Names([]); }}
           style={{ '--size': '30vw' }}
           label="Preview">
           {/* <label slot="label">{``}</label> */}
           {/* <section>{console.log(creative_Names)} */}
           {creative_Names &&
               <> {(creative_Names.length > 0 ?
                   <Swiper
                       spaceBetween={0}
                       pagination={true}
                       navigation={true}
                       modules={[Navigation, Pagination]}
                       className="mySwiper"
                       style={{ width: "460px" }}>
                       {creative_Names.map((campPreview) => <SwiperSlide><newStreamCreativeContext.Provider value={{ campPreview }}><PreviewFrameEdit showPreview={true} /></newStreamCreativeContext.Provider></SwiperSlide>)}</Swiper> : null)} </>
           }
           {/* </section> */}


       </SlDrawer>
</>)
}

export default NewsStream;